import React from "react";
import { Shield, XCircle } from "lucide-react";

export const TrustBar = () => (
  <section className="bg-slate-900/80 border-y border-white/10">
    <div className="mx-auto max-w-7xl px-6 py-4">
      <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-slate-400">
        <div className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-green-400" />
          <span>Independent service — not affiliated with any platform</span>
        </div>
        <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" />
        <div className="flex items-center gap-2">
          <XCircle className="w-4 h-4 text-yellow-400" />
          <span>No guarantees — outcomes depend on platform review</span>
        </div>
        <div className="hidden md:block w-1 h-1 rounded-full bg-slate-600" />
        <div className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-blue-400" />
          <span>No passwords or account access required</span>
        </div>
      </div>
    </div>
  </section>
);
